import { Fragment, useState, useRef, useEffect } from "react";
import LocalStorageService from "../../services/LocalStorageService";
import Header from "./components/Header/Header";
import COLORS from "../../theme/Colors";
import InputAdornment from "@mui/material/InputAdornment";
import { Autocomplete, Button, Typography } from "@mui/material";
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import HomeOutlinedIcon from '@mui/icons-material/HomeOutlined';
import DescriptionOutlinedIcon from '@mui/icons-material/DescriptionOutlined';
import VolumeUpOutlinedIcon from '@mui/icons-material/VolumeUpOutlined';
import BarChartIcon from '@mui/icons-material/BarChart';
import BusinessIcon from '@mui/icons-material/Business';
import BadgeIcon from '@mui/icons-material/Badge';
import CampaignIcon from '@mui/icons-material/Campaign';
import FormModal from "../../components/FormModal/FormModal";
import {
    Container,
    HeroWrapper,
    ContainerVideo,
    MediumContainer,
    Title,
    SearcherSubTitle,
    SubTitle,
    AnalyticsContainer,
    SearchTextInput,
    CenterContainer,
    SearcherContainer,
    SearcherTitle,
    StyledSearchIconForSearcher,
    CardsContainer,
    CardsDivider,
    HomeContainer,
    HomeCenterContent,
    AnalyticItemIcon,
    AnalyticItem,
    VideoOverlay,
    StatsHeader,
    StatsTitle,
    StatsDescription,
    TestimonialsWrapper,
    TestimonialCard,
    TestimonialQuote,
    TestimonialContent,
    TestimonialAuthorContainer,
    TestimonialAuthor,
    TestimonialRole,
} from "./styles/HomeStyles";
import { Swiper, SwiperSlide } from 'swiper/react';
import SwiperCore, { Navigation, Pagination, Autoplay } from 'swiper';
import 'swiper/swiper.min.css';
import 'swiper/components/navigation/navigation.min.css';
import 'swiper/components/pagination/pagination.min.css';

import Counter from "./components/Counter/Counter";
import ServiceCard from "./components/ServiceCard/ServiceCard";
import ServiceCarousel from "./components/ServiceCarousel/ServiceCarousel";
import StepByStep from "./components/StepByStep/StepByStep";
import { useHistory, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import { useQuery } from "react-query";
import { getVideoDataFromWordpress, getHomeDataFromWordpress, getHomeMetricsData } from "../../api/Home";
import { getAllServices } from "../../api/ListOfServicesPerCategory";
import { getAllCompanies } from "../../api/myCompany";
import LayoutFooter from "../../components/Footer/Footer";
import { SmallHeightDivider } from "../../theme/Styles";
import CenterLoading from "../../components/CenterLoading/CenterLoading";
import LoginOrRegisterModal from "../../components/LoginOrRegisterModal/LoginOrRegisterModal";
import WebIcon from "../../assets/icons/WebIcon.png";
import ValidUserIcon from "../../assets/icons/ValidUserIcon.png";
import CertifiedIcon from "../../assets/icons/CertifiedIcon.png";
import Fade from 'react-reveal/Fade';
import { generateSlug } from "../../utils/slugify";

SwiperCore.use([Navigation, Pagination, Autoplay]);

function Home() {
    const history = useHistory();
    const location = useLocation();
    const { authenticated } = useSelector((state) => state.authReducer);
    const isHero = location.pathname === '/' || location.pathname === '/public';

    const [showVideoOverlay, setShowVideoOverlay] = useState(true);
    const [topBarExpanded, setTopBarExpanded] = useState(false);
    const [loginModalOpen, setLoginModalOpen] = useState(false);
    const [newRequestModalOpen, setNewRequestModalOpen] = useState(false);
    const [selectedCategory, setSelectedCategory] = useState(null);
    const [selectedServiceId, setSelectedServiceId] = useState("");
    const [selectedCompany, setSelectedCompany] = useState("");
    const [pendingServiceId, setPendingServiceId] = useState(null);

    const { data: allCompanyImIn } = useQuery(['allCompaniesDataHome'], () => getAllCompanies(), { enabled: Boolean(authenticated) });
    const companies = allCompanyImIn?.payload || [];

    const servicesRef = useRef(null);

    // Detect when mitur-topbar expands/collapses its hidden content
    useEffect(() => {
        const checkTopBar = () => {
            const topBar = document.querySelector('mitur-topbar');
            if (!topBar) return;
            const inner = topBar.shadowRoot?.querySelector('[class*="expand"], [aria-expanded="true"], .open, .expanded');
            setTopBarExpanded(!!inner);
        };

        const observer = new MutationObserver(checkTopBar);
        const topBar = document.querySelector('mitur-topbar');
        if (topBar) {
            observer.observe(topBar, { attributes: true, childList: true, subtree: true });
        }
        observer.observe(document.body, { attributes: true, attributeFilter: ['class'] });

        const onOpen  = () => setTopBarExpanded(true);
        const onClose = () => setTopBarExpanded(false);
        document.addEventListener('topbar:open',  onOpen);
        document.addEventListener('topbar:close', onClose);
        window.addEventListener('topbar:open',   onOpen);
        window.addEventListener('topbar:close',  onClose);

        return () => {
            observer.disconnect();
            document.removeEventListener('topbar:open',  onOpen);
            document.removeEventListener('topbar:close', onClose);
            window.removeEventListener('topbar:open',   onOpen);
            window.removeEventListener('topbar:close',  onClose);
        };
    }, []);

    const { data: homeContent, isLoading: homeContentIsLoading } = useQuery(["homeData"], () => getHomeDataFromWordpress());
    const { data: videoContent, isLoading: videoContentIsLoading } = useQuery(["videoData"], () => getVideoDataFromWordpress());
    const { data: listOfServices, isLoading: listOfServicesIsLoading } = useQuery(["listOfServices"], () => getAllServices());
    const { data: homeMetricsData, isLoading: homeMetricsDataIsLoading } = useQuery(["homeMetricsData"], () => getHomeMetricsData());

    const categoriesModal = (listOfServices || []).map((cat) => {
        let icon = <BarChartIcon />;
        const catNameLower = String(cat.name || "").toLowerCase();

        if (catNameLower.includes("confotur") || catNameLower.includes("incentivo")) {
            icon = <BusinessIcon />;
        } else if (catNameLower.includes("licencia") || catNameLower.includes("operac")) {
            icon = <BadgeIcon />;
        } else if (catNameLower.includes("mercadeo") || catNameLower.includes("promoc")) {
            icon = <CampaignIcon />;
        } else if (catNameLower.includes("dpp") || catNameLower.includes("proyect") || catNameLower.includes("evaluac")) {
            icon = <BarChartIcon />;
        }

        return {
            id: cat.id,
            title: cat.name,
            description: cat.description || `Servicios y trámites pertenecientes a ${cat.name}.`,
            icon: icon
        };
    });

    const defaultHomeCategories = [
        {
            id: 'confotur',
            name: 'Clasificaciones de Confotur',
            description: 'Aprobación —provisional o definitiva— de un proyecto turístico por el Consejo de Fomento Turístico (CONFOTUR).',
            tag: 'INCENTIVOS',
            icon: <HomeOutlinedIcon sx={{ fontSize: 26 }} />,
            cardClass: 'uctt-card c-lar',
            linkCategory: 'confotur'
        },
        {
            id: 'licencias',
            name: 'Licencias de Operación',
            description: 'Emisión de licencia mediante resolución para operar como proveedor de servicios turísticos.',
            tag: 'OPERACIÓN',
            icon: <DescriptionOutlinedIcon sx={{ fontSize: 26 }} />,
            cardClass: 'uctt-card c-amb',
            linkCategory: 'licencia-de-operacion'
        },
        {
            id: 'mercadeo',
            name: 'Mercadeo',
            description: 'Servicios de promoción y mercadeo turístico abiertos a todo el público.',
            tag: 'PROMOCIÓN',
            icon: <VolumeUpOutlinedIcon sx={{ fontSize: 26 }} />,
            cardClass: 'uctt-card c-nav',
            linkCategory: 'mercadeo'
        }
    ];

    const categoriesToDisplay = (listOfServices && listOfServices.length > 0)
        ? listOfServices.map((cat, idx) => {
            const catNameLower = String(cat.name || "").toLowerCase();
            const tag = cat.tag || cat.badge || cat.short_name || (
                catNameLower.includes("confotur") || catNameLower.includes("incentivo") ? "INCENTIVOS" :
                catNameLower.includes("licencia") || catNameLower.includes("operac") ? "OPERACIÓN" :
                catNameLower.includes("mercadeo") || catNameLower.includes("promoc") ? "PROMOCIÓN" :
                catNameLower.includes("dpp") || catNameLower.includes("evaluac") || catNameLower.includes("proyect") ? "EVALUACIÓN" :
                catNameLower.includes("fomento") ? "FOMENTO" :
                (cat.name ? cat.name.trim().split(/\s+/)[0].toUpperCase() : "TRÁMITES")
            );

            let icon = <HomeOutlinedIcon sx={{ fontSize: 26 }} />;
            let cardClass = "uctt-card c-lar";

            if (catNameLower.includes("confotur") || catNameLower.includes("incentivo")) {
                icon = <HomeOutlinedIcon sx={{ fontSize: 26 }} />;
                cardClass = "uctt-card c-lar";
            } else if (catNameLower.includes("licencia") || catNameLower.includes("operac")) {
                icon = <DescriptionOutlinedIcon sx={{ fontSize: 26 }} />;
                cardClass = "uctt-card c-amb";
            } else if (catNameLower.includes("mercadeo") || catNameLower.includes("promoc")) {
                icon = <VolumeUpOutlinedIcon sx={{ fontSize: 26 }} />;
                cardClass = "uctt-card c-nav";
            } else if (catNameLower.includes("dpp") || catNameLower.includes("proyect") || catNameLower.includes("evaluac")) {
                icon = <BarChartIcon sx={{ fontSize: 26 }} />;
                cardClass = "uctt-card c-lar";
            } else {
                const classes = ["uctt-card c-lar", "uctt-card c-amb", "uctt-card c-nav"];
                const icons = [
                    <HomeOutlinedIcon sx={{ fontSize: 26 }} />,
                    <DescriptionOutlinedIcon sx={{ fontSize: 26 }} />,
                    <VolumeUpOutlinedIcon sx={{ fontSize: 26 }} />,
                    <BarChartIcon sx={{ fontSize: 26 }} />
                ];
                cardClass = classes[idx % classes.length];
                icon = icons[idx % icons.length];
            }

            return {
                id: cat.id,
                name: cat.name,
                description: cat.description || `Servicios y trámites pertenecientes a ${cat.name}.`,
                tag: tag,
                icon: icon,
                cardClass: cardClass,
                linkCategory: generateSlug(cat.name || "")
            };
        })
        : defaultHomeCategories;

    const getServicesForCategoryModal = (catId) => {
        if (!listOfServices) return [];
        const found = (listOfServices || []).find(c => String(c.id) === String(catId));
        if (found && found.services) {
            return found.services;
        }
        return [];
    };

    const handleConfirmStartRequest = () => {
        if (!selectedServiceId) return;

        const targetService = (listOfServices || []).flatMap(c => c.services || []).find(s => String(s.id) === String(selectedServiceId));
        const targetSlug = targetService ? (targetService.slug || generateSlug(targetService.name)) : selectedServiceId;
        
        let targetPath = `/solicitar-tramite/${targetSlug}`;
        if (selectedCompany) {
            const [company_id, company_name] = selectedCompany.split(",");
            targetPath = `/solicitar-tramite/${targetSlug}/${company_id}/${encodeURIComponent(company_name)}`;
        }
        
        if (authenticated) {
            setNewRequestModalOpen(false);
            history.push(targetPath);
        } else {
            setPendingServiceId(selectedServiceId);
            setNewRequestModalOpen(false);
            LocalStorageService.setItem("redirect_after_login", targetPath);
            setLoginModalOpen(true);
        }
    };

    const goToSelectedService = (service) => {
        if (service && service.title) {
            history.push(`/tramite/${generateSlug(service.title)}`);
        }
    };

    if (homeContentIsLoading || videoContentIsLoading || listOfServicesIsLoading || homeMetricsDataIsLoading) return <CenterLoading />;

    const ServicesForSearcher = (listOfServices || [])
    .flatMap(list => list?.services || [])
    .map(item => ({
        id: item.id,
        title: item.name
    }));

    const handleShowVideoOverlay = () => {
        setShowVideoOverlay(false);
    };

    const testimonials = [
        {
            name: "Aristides Rafael Ramirez",
            initials: "AR",
            text: "Excelente y pronta respuesta para todo. No hay quejas mas allá de que uno siempre quiere mas rapidez, pero sabemos que los tramites tienen su tiempo de estudio y respuesta. Al final, lo más importante son los resultados y fueron positivos.",
            role: "Ciudadano"
        },
        {
            name: "Carlos Reyes",
            initials: "CR",
            text: "Una excelente plataforma, facil acceso y buena dinámica de principio a fin.",
            role: "Ciudadano"
        },
        {
            name: "Elsa María Rivera Reyes",
            initials: "ER",
            text: "Servicio rápido y fiable. ¡Excelente experiencia con el portal del turismo, gracias!",
            role: "Ciudadana"
        },
        {
            name: "Jose Ramon Lopez",
            initials: "JL",
            text: "El proceso fue claro durante todo el trayecto de solicitud y la comunicación estuvo muy buena cada vez que necesitaron un requisito adicional. Estamos conformes con el resultado.",
            role: "Ciudadano"
        },
        {
            name: "Eusebio Vasquez",
            initials: "EV",
            text: "Un servicio muy eficiente y claras respuestas a cada pregunta surgida.",
            role: "Ciudadano"
        }
    ];

    return (
        <Container>
            {/* HERO BANNER CON IMAGEN DE FONDO & ALINEADO A LA IZQUIERDA */}
            <HeroWrapper style={{ marginTop: topBarExpanded ? '80px' : '0' }}>
                <Header servicesRef={servicesRef} isHero={isHero} />
                <HomeContainer image={'/asael-pena-VmhjQw6PDPQ-unsplash.jpg'}>
                    <div style={{
                        width: '100%',
                        maxWidth: '1240px',
                        margin: '0 auto',
                        padding: '140px 24px 100px 24px',
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'flex-start',
                        textAlign: 'left'
                    }}>
                        <Fade bottom>
                            <span className="uctt-eyebrow no-dash" style={{ color: '#FFFFFF', justifyContent: 'flex-start' }}>
                                Ventanilla única
                            </span>
                        </Fade>
                        <Fade bottom delay={150}>
                            <h1 style={{
                                color: '#FFFFFF',
                                fontWeight: 800,
                                fontSize: 'clamp(36px, 4.8vw, 56px)',
                                lineHeight: 1.15,
                                margin: '16px 0',
                                textAlign: 'left'
                            }}>
                                Todos tus trámites<br />
                                turísticos, en <span style={{ color: COLORS.primary, position: 'relative', whiteSpace: 'nowrap' }}>un solo lugar</span>
                            </h1>
                        </Fade>
                        <Fade bottom delay={250}>
                            <p style={{
                                color: 'rgba(255, 255, 255, 0.9)',
                                fontSize: '18px',
                                maxWidth: '580px',
                                margin: '0 0 30px 0',
                                lineHeight: 1.6,
                                textAlign: 'left'
                            }}>
                                La Unidad Central de Trámites Turísticos reúne la solicitud, el seguimiento y el pago de los servicios del sector en un mismo portal.
                            </p>
                        </Fade>
                        <Fade bottom delay={350}>
                            <div className="uctt-cmd" style={{ width: '100%', maxWidth: '560px', marginRight: 'auto' }}>
                                <StyledSearchIconForSearcher style={{ color: COLORS.tertiary, marginLeft: 4 }} />
                                <Autocomplete
                                    options={ServicesForSearcher}
                                    getOptionLabel={(option) => option.title}
                                    autoHighlight
                                    freeSolo
                                    style={{ width: "100%" }}
                                    onChange={(e, newValue) => {
                                        goToSelectedService(newValue);
                                    }}
                                    onKeyDown={(event) => {
                                        if (event.key === "Enter") {
                                            event.defaultMuiPrevented = true;
                                        }
                                    }}
                                    renderInput={(params) => (
                                        <SearchTextInput
                                            {...params}
                                            fullWidth
                                            placeholder="¿Qué trámite o servicio necesitas?"
                                            variant="standard"
                                            InputProps={{
                                                ...params.InputProps,
                                                disableUnderline: true,
                                                autoComplete: "new-password",
                                                style: { color: COLORS.black, fontSize: '16px' }
                                            }}
                                        />
                                    )}
                                />
                                <Button
                                    variant="contained"
                                    sx={{
                                        bgcolor: COLORS.primary,
                                        color: 'white',
                                        borderRadius: 3,
                                        px: 3,
                                        py: 1.2,
                                        fontWeight: 700,
                                        textTransform: 'none',
                                        boxShadow: 'none',
                                        '&:hover': { bgcolor: COLORS.secondary }
                                    }}
                                >
                                    Buscar
                                </Button>
                            </div>
                            <div className="uctt-pop" style={{ justifyContent: 'flex-start', marginTop: '22px' }}>
                                <span className="k" style={{ color: 'rgba(255, 255, 255, 0.8)' }}>Populares</span>
                                <a className="uctt-chip" href="#" onClick={(e) => { e.preventDefault(); history.push('/todos-los-tramites?categoria=confotur'); }}>
                                    Confotur
                                </a>
                                <a className="uctt-chip" href="#" onClick={(e) => { e.preventDefault(); history.push('/todos-los-tramites?categoria=licencia-de-operacion'); }}>
                                    Licencia
                                </a>
                                <a className="uctt-chip" href="#" onClick={(e) => { e.preventDefault(); history.push('/todos-los-tramites?categoria=dpp'); }}>
                                    DPP
                                </a>
                            </div>
                        </Fade>
                    </div>
                </HomeContainer>
            </HeroWrapper>

            {/* SECCIÓN PASO A PASO */}
            <StepByStep onActionClick={() => {
                setNewRequestModalOpen(true);
            }} />

            {/* SECCIÓN GESTIÓN EN CIFRAS */}
            <MediumContainer style={{ backgroundColor: COLORS.secondary }}>
                <Fade bottom>
                    <StatsHeader>
                        <StatsTitle>Nuestra gestión en cifras</StatsTitle>
                        <StatsDescription>
                            Seguimiento en tiempo real del impacto de la UCTT en la agilización de servicios para el ciudadano.
                        </StatsDescription>
                    </StatsHeader>
                </Fade>
                <AnalyticsContainer>
                    <Fade bottom cascade delay={200}>
                        <AnalyticItem>
                            <AnalyticItemIcon>
                                <img src={WebIcon} alt="Solicitudes" />
                            </AnalyticItemIcon>
                            <Title>
                                +<Counter target={homeMetricsData?.requests || 0} />
                            </Title>
                            <SubTitle>Solicitudes realizadas</SubTitle>
                        </AnalyticItem>
                        <AnalyticItem>
                            <AnalyticItemIcon>
                                <img src={ValidUserIcon} alt="Usuarios" />
                            </AnalyticItemIcon>
                            <Title>
                                +<Counter target={homeMetricsData?.citizens || 0} />
                            </Title>
                            <SubTitle>Usuarios registrados</SubTitle>
                        </AnalyticItem>
                        <AnalyticItem>
                            <AnalyticItemIcon>
                                <img src={CertifiedIcon} alt="Consultas" />
                            </AnalyticItemIcon>
                            <Title>
                                +<Counter target={homeMetricsData?.visits || 0} />
                            </Title>
                            <SubTitle>Consultas a servicios</SubTitle>
                        </AnalyticItem>
                    </Fade>
                </AnalyticsContainer>
            </MediumContainer>

            {/* SECCIÓN TRÁMITES / DIRECTORIO - EXACT MATCH TO ATTACHED DESIGN */}
            <div className="uctt-tramites-section" style={{ backgroundColor: '#F1F6F7', padding: '80px 0', width: '100%' }}>
                <div ref={servicesRef} style={{ maxWidth: '1240px', margin: '0 auto', padding: '0 24px' }}>
                    <Fade bottom>
                        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', textAlign: 'center', marginBottom: '44px' }}>
                            <span className="uctt-eyebrow no-dash" style={{ justifyContent: 'center', color: '#0B8296' }}>Directorio</span>
                            <Typography
                                variant="h2"
                                sx={{
                                    color: '#0F2350',
                                    mt: 1.5,
                                    mb: 1.5,
                                    fontWeight: 900,
                                    fontSize: { xs: '2rem', md: '2.7rem' },
                                    fontFamily: 'Merriweather, serif',
                                    letterSpacing: '-0.02em'
                                }}
                            >
                                Trámites que ofrece la UCTT
                            </Typography>
                            <Typography
                                variant="body1"
                                sx={{
                                    color: '#57697F',
                                    fontSize: '1.05rem',
                                    maxWidth: 720,
                                    lineHeight: 1.6,
                                    fontFamily: 'Roboto, sans-serif'
                                }}
                            >
                                Del análisis del suelo a la licencia de operación: un servicio integrado para gestionar la inversión turística.
                            </Typography>
                        </div>
                    </Fade>

                    <Fade bottom delay={200}>
                        <div style={{ marginBottom: '28px', width: '100%' }}>
                            {categoriesToDisplay.length > 3 ? (
                                <Swiper
                                    spaceBetween={24}
                                    slidesPerView={1}
                                    autoplay={{
                                        delay: 5000,
                                        disableOnInteraction: false,
                                    }}
                                    pagination={{
                                        clickable: true,
                                        dynamicBullets: true,
                                    }}
                                    navigation={true}
                                    breakpoints={{
                                        640: { slidesPerView: 1 },
                                        768: { slidesPerView: 2 },
                                        1024: { slidesPerView: 3 },
                                    }}
                                    style={{
                                        padding: '10px 10px 50px 10px',
                                        overflow: 'hidden'
                                    }}
                                >
                                    {categoriesToDisplay.map((cat, idx) => (
                                        <SwiperSlide key={cat.id || idx} style={{ height: 'auto' }}>
                                            <div className={cat.cardClass} style={{ height: '100%', minHeight: '210px' }}>
                                                <div className="top">
                                                    <div className="i" style={{ backgroundColor: '#E7ECF6', color: COLORS.secondary }}>
                                                        {cat.icon}
                                                    </div>
                                                    <span className="tag" style={{ backgroundColor: '#E7ECF6', color: COLORS.secondary }}>
                                                        {cat.tag}
                                                    </span>
                                                </div>
                                                <h3 style={{ fontFamily: 'Merriweather, serif', color: '#0F2350' }}>
                                                    {cat.name}
                                                </h3>
                                                <p>
                                                    {cat.description}
                                                </p>
                                                <a
                                                    href="#"
                                                    className="go"
                                                    style={{ color: COLORS.secondary }}
                                                    onClick={(e) => {
                                                        e.preventDefault();
                                                        history.push(`/todos-los-tramites?categoria=${cat.linkCategory}`);
                                                    }}
                                                >
                                                    Ver trámites <ArrowForwardIcon sx={{ fontSize: 16 }} />
                                                </a>
                                            </div>
                                        </SwiperSlide>
                                    ))}
                                </Swiper>
                            ) : (
                                <div className="uctt-dir-grid cols-3">
                                    {categoriesToDisplay.map((cat, idx) => (
                                        <div key={cat.id || idx} className={cat.cardClass}>
                                            <div className="top">
                                                <div className="i" style={{ backgroundColor: '#E7ECF6', color: COLORS.secondary }}>
                                                    {cat.icon}
                                                </div>
                                                <span className="tag" style={{ backgroundColor: '#E7ECF6', color: COLORS.secondary }}>
                                                    {cat.tag}
                                                </span>
                                            </div>
                                            <h3 style={{ fontFamily: 'Merriweather, serif', color: '#0F2350' }}>
                                                {cat.name}
                                            </h3>
                                            <p>
                                                {cat.description}
                                            </p>
                                            <a
                                                href="#"
                                                className="go"
                                                style={{ color: COLORS.secondary }}
                                                onClick={(e) => {
                                                    e.preventDefault();
                                                    history.push(`/todos-los-tramites?categoria=${cat.linkCategory}`);
                                                }}
                                            >
                                                Ver trámites <ArrowForwardIcon sx={{ fontSize: 16 }} />
                                            </a>
                                        </div>
                                    ))}
                                </div>
                            )}
                        </div>
                    </Fade>

                    {/* Bottom AllBar Callout */}
                    <Fade bottom delay={300}>
                        <div className="uctt-allbar">
                            <p style={{ margin: 0, color: '#57697F', fontSize: '15px' }}>
                                <b style={{ color: '#0F2350', fontWeight: 800 }}>¿No encuentras tu trámite?</b> Explora el directorio completo por dirección y categoría.
                            </p>
                            <Button
                                variant="contained"
                                sx={{
                                    bgcolor: '#0F2350',
                                    color: 'white',
                                    borderRadius: '12px',
                                    px: 3.5,
                                    py: 1.4,
                                    fontWeight: 700,
                                    fontSize: '0.95rem',
                                    textTransform: 'none',
                                    boxShadow: '0 4px 14px rgba(15, 35, 80, 0.2)',
                                    '&:hover': { bgcolor: '#EA361A' }
                                }}
                                onClick={() => history.push('/todos-los-tramites')}
                            >
                                Ver directorio completo
                            </Button>
                        </div>
                    </Fade>
                </div>
            </div>

            {/* SECCIÓN VIDEO */}
            <ContainerVideo>
                <div style={{ width: '100%', height: '100%' }}>
                    {showVideoOverlay ? (
                        <VideoOverlay display={showVideoOverlay ? "flex" : "none"} onClick={handleShowVideoOverlay} />
                    ) : (
                        <iframe
                            width="100%"
                            title="MITUR Video"
                            style={{ border: 0, height: "100vh" }}
                            frameBorder="0"
                            allow="autoplay"
                            encrypted-media
                            allowFullScreen
                            loading="lazy"
                            src={`${videoContent?.video_url}?autoplay=1&loop=1`}
                        />
                    )}
                </div>
            </ContainerVideo>

            {/* SECCIÓN TESTIMONIOS */}
            <TestimonialsWrapper>
                <Fade bottom>
                    <div style={{ textAlign: 'center', marginBottom: '40px' }}>
                        <span className="uctt-eyebrow no-dash" style={{ justifyContent: 'center' }}>Testimonios</span>
                        <StatsTitle style={{ color: COLORS.secondary, marginTop: '12px', fontWeight: 800 }}>Lo que dicen los ciudadanos</StatsTitle>
                        <StatsDescription style={{ color: '#57697F' }}>
                            Experiencias reales de quienes ya gestionaron sus trámites a través del portal.
                        </StatsDescription>
                    </div>
                </Fade>
                
                <CenterContainer style={{ width: '90%' }}>
                    <Swiper
                        spaceBetween={30}
                        slidesPerView={1}
                        pagination={{ clickable: true, dynamicBullets: true }}
                        autoplay={{ delay: 6000 }}
                        breakpoints={{
                            768: { slidesPerView: 2 },
                            1024: { slidesPerView: 3 }
                        }}
                        style={{ paddingBottom: '60px', width: '100%' }}
                    >
                        {testimonials.map((t, idx) => (
                            <SwiperSlide key={idx}>
                                <TestimonialCard style={{ borderRadius: '16px', padding: '18px 20px', border: '1px solid #E1E9EC', boxShadow: '0 4px 12px rgba(15,35,80,0.04)', margin: 0 }}>
                                    <div style={{ display: 'flex', gap: '2px', color: '#E2912B', marginBottom: '6px', fontSize: '15px' }}>
                                        ★★★★★
                                    </div>
                                    <TestimonialContent 
                                        style={{ 
                                            color: '#334155', 
                                            fontSize: '13.5px', 
                                            fontStyle: 'normal', 
                                            lineHeight: '1.5',
                                            margin: '4px 0 10px 0',
                                            padding: 0,
                                            display: '-webkit-box',
                                            WebkitLineClamp: 4,
                                            WebkitBoxOrient: 'vertical',
                                            overflow: 'hidden',
                                            textOverflow: 'ellipsis'
                                        }}
                                    >
                                        "{t.text}"
                                    </TestimonialContent>
                                    <TestimonialAuthorContainer style={{ display: 'flex', alignItems: 'center', gap: '10px', paddingTop: '10px', borderTop: '1px solid #F1F5F9', marginTop: 'auto', textAlign: 'left', justifyContent: 'flex-start' }}>
                                        <div style={{
                                            width: '36px',
                                            height: '36px',
                                            borderRadius: '50%',
                                            background: 'linear-gradient(135deg, #0063bc, #202a5d)',
                                            color: '#FFFFFF',
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            fontWeight: 800,
                                            fontSize: '13px',
                                            flexShrink: 0
                                        }}>
                                            {t.initials || t.name.substring(0, 2).toUpperCase()}
                                        </div>
                                        <div style={{ textAlign: 'left' }}>
                                            <TestimonialAuthor style={{ color: COLORS.secondary, fontWeight: 700, fontSize: '13.5px', margin: 0, lineHeight: 1.2, textAlign: 'left' }}>{t.name}</TestimonialAuthor>
                                            <TestimonialRole style={{ color: '#8A99AC', fontSize: '11px', letterSpacing: '0.08em', fontWeight: 600, display: 'block', marginTop: '2px', textAlign: 'left' }}>{t.role}</TestimonialRole>
                                        </div>
                                    </TestimonialAuthorContainer>
                                </TestimonialCard>
                            </SwiperSlide>
                        ))}
                    </Swiper>
                </CenterContainer>
            </TestimonialsWrapper>
            
            <LayoutFooter showNewsletter />

            {/* MODAL DE INICIAR NUEVO TRÁMITE DIRECTAMENTE EN EL INDEX */}
            <FormModal 
                open={newRequestModalOpen} 
                onClose={() => { setNewRequestModalOpen(false); setSelectedCategory(null); setSelectedServiceId(""); }} 
                title="Iniciar Nuevo Trámite"
                maxWidth="md"
                fullWidth={true}
            >
                <div style={{ padding: "8px 16px 24px 16px", fontFamily: "Roboto, sans-serif" }}>
                    <p style={{ color: "#57697F", fontSize: "14.5px", margin: "12px 0 24px 0", fontWeight: "500" }}>
                        Seleccione el tipo de servicio que desea solicitar:
                    </p>

                    <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(170px, 1fr))", gap: "16px", marginBottom: "24px" }}>
                        {categoriesModal.map((cat) => {
                            const isSelected = selectedCategory === cat.id;
                            return (
                                <div 
                                    key={cat.id}
                                    onClick={() => { setSelectedCategory(cat.id); setSelectedServiceId(""); }}
                                    style={{
                                        border: isSelected ? "2px solid #0063bc" : "1px solid #E1E9EC",
                                        borderRadius: "14px",
                                        padding: "20px 14px",
                                        display: "flex",
                                        flexDirection: "column",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        textAlign: "center",
                                        gap: "12px",
                                        cursor: "pointer",
                                        backgroundColor: isSelected ? "#F0F4FF" : "#FFFFFF",
                                        boxShadow: isSelected ? "0px 4px 14px rgba(0, 99, 188, 0.12)" : "0px 2px 4px rgba(0,0,0,0.02)",
                                        transition: "all 0.2s ease"
                                    }}
                                >
                                    <div 
                                        style={{
                                            width: "44px",
                                            height: "44px",
                                            borderRadius: "10px",
                                            backgroundColor: isSelected ? "#0063bc" : "#E3F4F6",
                                            color: isSelected ? "#FFFFFF" : "#0063bc",
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "center",
                                            flexShrink: 0
                                        }}
                                    >
                                        {cat.icon}
                                    </div>
                                    <span style={{ fontWeight: "700", fontSize: "13.5px", color: "#0F2350", lineHeight: "18px" }}>
                                        {cat.title}
                                    </span>
                                </div>
                            );
                        })}
                    </div>

                    {selectedCategory && (
                        <div style={{ marginTop: "20px", display: "flex", flexDirection: "column", gap: "8px", marginBottom: "20px" }}>
                            <label style={{ fontSize: "14px", fontWeight: "700", color: "#0F2350" }}>
                                Servicio específico:
                            </label>
                            <select 
                                value={selectedServiceId} 
                                onChange={(e) => setSelectedServiceId(e.target.value)}
                                style={{
                                    width: "100%",
                                    padding: "12px 14px",
                                    borderRadius: "10px",
                                    border: "1px solid #CFDCE0",
                                    backgroundColor: "#FFFFFF",
                                    fontFamily: "Roboto, sans-serif",
                                    fontSize: "14px",
                                    color: "#0F2350",
                                    outline: "none"
                                }}
                            >
                                <option value="" disabled>-- Seleccione un servicio --</option>
                                {getServicesForCategoryModal(selectedCategory).map(service => (
                                    <option key={service.id} value={service.id}>
                                        {service.name}
                                    </option>
                                ))}
                            </select>
                        </div>
                    )}

                    {selectedServiceId && authenticated && companies && companies.length > 0 && (
                        <div style={{ marginTop: "20px", display: "flex", flexDirection: "column", gap: "8px", marginBottom: "20px" }}>
                            <label style={{ fontSize: "14px", fontWeight: "700", color: "#0F2350" }}>
                                Solicitar en representación de:
                            </label>
                            <select 
                                value={selectedCompany} 
                                onChange={(e) => setSelectedCompany(e.target.value)}
                                style={{
                                    width: "100%",
                                    padding: "12px 14px",
                                    borderRadius: "10px",
                                    border: "1px solid #CFDCE0",
                                    backgroundColor: "#FFFFFF",
                                    fontFamily: "Roboto, sans-serif",
                                    fontSize: "14px",
                                    color: "#0F2350",
                                    outline: "none"
                                }}
                            >
                                <option value="">A título personal</option>
                                {companies.map(comp => (
                                    <option key={comp.id || comp.company_rnc} value={`${comp.id},${comp.company_name}`}>
                                        {comp.company_name} (RNC: {comp.company_rnc})
                                    </option>
                                ))}
                            </select>
                        </div>
                    )}

                    <div style={{ display: "flex", justifyContent: "flex-end", gap: "12px", marginTop: "24px", paddingTop: "16px", borderTop: "1px solid #E1E9EC" }}>
                        <Button 
                            variant="outlined"
                            onClick={() => setNewRequestModalOpen(false)}
                            sx={{
                                color: "#57697F",
                                borderColor: "#CFDCE0",
                                textTransform: "none",
                                fontWeight: 700,
                                borderRadius: "10px",
                                px: 3
                            }}
                        >
                            Cancelar
                        </Button>
                        <Button 
                            variant="contained"
                            disabled={!selectedServiceId}
                            onClick={handleConfirmStartRequest}
                            sx={{
                                bgcolor: "#EA361A",
                                color: "#FFFFFF",
                                textTransform: "none",
                                fontWeight: 700,
                                borderRadius: "10px",
                                px: 4,
                                '&:hover': { bgcolor: "#202a5d" }
                            }}
                        >
                            Iniciar Solicitud
                        </Button>
                    </div>
                </div>
            </FormModal>

            <LoginOrRegisterModal 
                open={loginModalOpen}
                onCloseClick={() => setLoginModalOpen(false)}
                onBackDropClick={() => setLoginModalOpen(false)}
            />
        </Container>
    );
}

export default Home;
